import { Component, OnInit } from "@angular/core";
import { FlashController } from "../../flash-payment-core/services/flash-controller.service";
import { GlobalService } from '../../../global.service';
import { Subscription } from 'rxjs';

@Component({
  selector: "app-way-to-pay",
  templateUrl: "./way-to-pay.component.html",
  styleUrls: ["./way-to-pay.component.sass"],
})
export class WayToPayComponent implements OnInit {

  openForm = false;
  showOptionList = false;
  cantShowArrows = true;
  listenToken: Subscription;

  constructor(public flashPaymentService: FlashController, private global: GlobalService) {
    this.listenToken = this.flashPaymentService.mustOpenForm.subscribe(
      (data: boolean) => {
        this.openForm = data;
      }
    );
  }

  ngOnInit(): void {
    let amountFix = this.flashPaymentService.controller.operationAmount;
    amountFix = amountFix.replace('CR', '');
    this.flashPaymentService.controller.operationAmount = amountFix;
    if (this.flashPaymentService.controller.tokenCards.length > 1) {
      this.cantShowArrows = true;
    }
  }

  selectPaymentOption(evt) {
    this.openForm = evt.openForm;
    this.showOptionList = evt.showOptionList;
  }

  changeIcon(even) {
    if (even) {
      this.openForm = !this.openForm;
    }
  }
}
